import { format } from "rut.js";
import { columns } from "../../../../dtos/columns";
import { ArchivoMinvuDTO } from "../models/cobroSeguros";

export function useColumns() {

    const COLUMNS: columns<ArchivoMinvuDTO>[] = [
        {
            name: 'SCI_PER_RUT',
            selector: (row) =>
                row.sciPerRut,
            sortable: true,
            sortField: 'sciPerRut',
            wrap: true,
            export: true
        },
        {
            name: 'SCI_PER_DV',
            selector: (row) => row.sciPerDv,
            sortable: true,
            sortField: 'sciPerDv',
            wrap: true,
            export: true,
            alling: 'left'

        },
        {
            name: 'SCI_ID_PER_PAT',
            selector: (row) =>
                `${row.sciIdPerPat}`,
            sortable: true,
            sortField: 'sciIdPerPat',
            wrap: true,
            export: true,
            alling: 'left'

        },
        {
            name: 'SCI_ID_PER_MAT',
            selector: (row) =>
                `${row.sciIdPerMat}`,
            sortable: true,
            sortField: 'sciIdPerMat',
            wrap: true,
            export: true,
            alling: 'left'

        },
        {
            name: 'SCI_ID_PER_NOM',
            selector: (row) =>
                row.sciIdPerNom,
            sortable: true,
            sortField: 'sciIdPerNom',
            wrap: true,
            export: true,
        },
        {
            name: 'SCI_ENT_ID',
            selector: (row) =>
                row.sciEntId,
            sortable: true,
            sortField: 'sciEntId',
            wrap: true,
            export: true,
        },

        {
            name: 'SCI_REG_ID',
            selector: (row) =>
                row.sciRegId,
            sortable: true,
            sortField: 'sciRegId',
            wrap: true,
            export: true,
        },
        {
            name: 'SCI_PRG_ID',
            selector: (row) =>
                row.sciPrgId,
            sortable: true,
            sortField: 'sciPrgId',
            wrap: true,
            export: true,
        },
        {
            name: 'SCI_ID_MON',
            selector: (row) =>
                row.sciIdMon,
            sortable: true,
            sortField: 'sciIdMon',
            wrap: true,
            export: true,
        },
        {
            name: 'SCI_ID_MON',
            selector: (row) =>
                row.sciIdMon,
            sortable: true,
            sortField: 'sciIdMon',
            wrap: true,
            export: true,
        },
        {
            name: 'SCI_ID_MON',
            selector: (row) =>
                row.sciIdMon,
            sortable: true,
            sortField: 'sciIdMon',
            wrap: true,
            export: true,
        },
        {
            name: 'SCI_CYG_RUT',
            selector: (row) =>
                row.sciCygRut,
            sortable: true,
            sortField: 'sciCygRut',
            wrap: true,
            export: true,
        },
        {
            name: 'SCI_CYG_DV',
            selector: (row) =>
                row.sciCygDv,
            sortable: true,
            sortField: 'sciCygDv',
            wrap: true,
            export: true,
        },
        {
            name: 'SCI_ID_CYG_PAT',
            selector: (row) =>
                `${row.sciIdCygPat}`,
            sortable: true,
            sortField: 'sciIdCygPat',
            wrap: true,
            export: true,
        },
        {
            name: 'SCI_ID_CYG_MAT',
            selector: (row) =>
                `${row.sciIdCygMat}`,
            sortable: true,
            sortField: 'sciIdCygMat',
            wrap: true,
            export: true,
        },
        {
            name: 'SCI_ID_CYG_NOM',
            selector: (row) =>
                `${row.sciIdCygNom}`,
            sortable: true,
            sortField: 'sciIdCygNom',
            wrap: true,
            export: true,
        },
        {
            name: 'SCI_NRO_PLZA',
            selector: (row) =>
                row.sciNroPlza,
            sortable: true,
            sortField: 'sciNroPlza',
            wrap: true,
            export: true,
        }
        ,
        {
            name: 'SCI_MON_PRI',
            selector: (row) =>
                row.sciMonPri,
            sortable: true,
            sortField: 'sciMonPri',
            wrap: true,
            export: true,
        }
        ,
        {
            name: 'SCI_MON_VIV',
            selector: (row) =>
                row.sciMonViv,
            sortable: true,
            sortField: 'sciMonViv',
            wrap: true,
            export: true,
        }
        ,
        {
            name: 'SCI_TOT_MON_CRE',
            selector: (row) =>
                row.sciTotMonCre,
            sortable: true,
            sortField: 'sciTotMonCre',
            wrap: true,
            export: true,
        }
        ,
        {
            name: 'SCI_NRO_OPE',
            selector: (row) =>
                row.sciNroOpe,
            sortable: true,
            sortField: 'sciNroOpe',
            wrap: true,
            export: true,
        }
        ,
        {
            name: 'SCI_FEC_ESC',
            selector: (row) =>
                row.sciFecEsc,
            sortable: true,
            sortField: 'sciFecEsc',
            wrap: true,
            export: true,
        }
        ,
        {
            name: 'SCI_FEC_INI_PLZ',
            selector: (row) =>
                row.sciFecIniPlz,
            sortable: true,
            sortField: 'sciFecIniPlz',
            wrap: true,
            export: true,
        }
        ,
        {
            name: 'SCI_FEC_TRM_PLZ',
            selector: (row) =>
                row.sciFecTrmPlz,
            sortable: true,
            sortField: 'sciFecTrmPlz',
            wrap: true,
            export: true,
        }
        ,
        {
            name: 'SCI_PLZ_CRE',
            selector: (row) =>
                row.sciPlzCre,
            sortable: true,
            sortField: 'sciPlzCre',
            wrap: true,
            export: true,
        }
        ,
        {
            name: 'SCI_FEC_PRI_DIV',
            selector: (row) =>
                row.sciFecPriDiv,
            sortable: true,
            sortField: 'sciFecPriDiv',
            wrap: true,
            export: true,
        }
        ,
        {
            name: 'SCI_FEC_ULT_DIV',
            selector: (row) =>
                row.sciFecUltDiv,
            sortable: true,
            sortField: 'sciFecUltDiv',
            wrap: true,
            export: true,
        },
        {
            name: 'SCI_NRO_DIV',
             selector: (row) =>
                row.sciFecUltDiv,
            sortable: true,
            sortField: 'sciFecUltDiv',
            wrap: true,
            export: true,
        },
        {
            name: 'SCI_RZN_ASG',
             selector: (row) =>
                row.sciRznAsg,
            sortable: true,
            sortField: 'sciRznAsg',
            wrap: true,
            export: true,
        },
        {
            name: 'SCI_VAL_MON',
             selector: (row) =>
                row.sciValMon,
            sortable: true,
            sortField: 'sciValMon',
            wrap: true,
            export: true,
        },
        {
            name: 'SCI_TOT_MONT_MVU',
             selector: (row) =>
                row.sciTotMontMvu,
            sortable: true,
            sortField: 'sciTotMontMvu',
            wrap: true,
            export: true,
        },
        {
            name: 'SCI_SEXO',
             selector: (row) =>
                row.sciSexo,
            sortable: true,
            sortField: 'sciSexo',
            wrap: true,
            export: true,
        }
    ]


    return { COLUMNS };
}